import 'bootstrap/dist/css/bootstrap.min.css';
import Form from 'react-bootstrap/Form';
import { Col, Container, Row, Button, Spinner, OverlayTrigger, Popover } from 'react-bootstrap';
import ChemComponent from '../ChemComponent';
import { withRouter } from '../withRouter';
import ChemEdit from '../ChemEdit';
import QueryTable from '../QueryTable';
import HashLink from '../HashLink';
import { PencilSquare, PlusSquare } from 'react-bootstrap-icons';

class Products extends ChemComponent {
	constructor(props) {
		super(props);

		var search = {
			PRODUCT_NAME: '',
			PRICE_DESC: ''
		};
		
		var productListInit = this.copyTable(productList);

		this.state = {
			productList: productListInit,
			search: search,
			searchCount: null,
			renderKey: 0
		};
	}
	
	onChangeSearch(accessor, value) {
		var search = this.copyObject(this.state.search);
		this.setByAccessor(search, accessor, value);
		this.mergeState({ search: search });
	}

	onSubmitSearch(event) {
		var newProductList = this.copyTable(productList);
		newProductList.query.search = this.constructSearch(this.state.search);
		this.mergeState({ 
			productList: newProductList,
			searchCount: null,
			renderKey: this.state.renderKey + 1
		});
		if (event && event.nativeEvent && event.nativeEvent.submitter) event.nativeEvent.submitter.blur();
	}
	
	constructSearch(data) {
		// construct search terms
		var search = {
			Operator: 'and',
			Children: []
		};

		if (!this.isEmpty(data.PRODUCT_NAME)) search.Children.push({ Attribute: 'PRODUCT_NAME', Operator: '=', StringValue: data.PRODUCT_NAME });
		if (!this.isEmpty(data.PRICE_DESC)) search.Children.push({ Attribute: 'PRICE_DESC', Operator: '=', StringValue: data.PRICE_DESC });

		// if there are no terms, forget it
		if (search.Children.length === 0) search = null;
		return search;
	}
	
	addProduct() {
		this.props.navigate('/HeLAD/Products/new');
	}
	
	editProduct(productId) {
		this.props.setProductEditable(true);
		this.props.navigate('/HeLAD/Products/' + productId);		
	}

	viewProduct(productId) {
		this.props.setProductEditable(false);
		this.props.navigate('/HeLAD/Products/' + productId);		
	}
	
	onSearchResult(data) {
		this.mergeState({
			searchCount: data.ResultCount
		});
	}

	render() {
		
		var exportData = this.createHiddenFormData({
			__RequestVerificationToken: this.props.user.antiForgeryToken,
			title: 'Products',
			columns: exportColumns,
			entity: 'LIQUID_AIR.DEWAR_PRODUCTS_VW',
			search: this.constructSearch(this.state.search)
		});
		
		return (<>
			<Container fluid>
			  <Row>
			    <Col style={{ paddingTop: '20px', marginBottom: '20px', border: '1px solid #ccc', borderRadius: 6, backgroundColor: '#FEFEFE' }}>
				  <Container fluid>	
					<Row>
					  <Col xs={12}>
						<span style={{ fontSize: '18px', fontWeight: 'bold' }}>Products</span>
						<ChemEdit parent={this} columns={productSearch} data={this.state.search} renderKey={this.state.renderKey} 
						  onChange={(accessor, value) => this.onChangeSearch(accessor, value)} {...this.props} />
					  </Col>
					</Row>
					<Form.Group as={Row} style={{ borderTop: '1px solid #eee', paddingTop: 10, marginBottom: 10 }}>
					  <Col xs={3} style={{ marginTop: 8}}>
						{this.isEmpty(this.state.searchCount) ? <Spinner animation='border' as='div' size='sm' style={{ marginRight: '4px' }} /> : this.state.searchCount} records found.
					  </Col>
					  <Col xs={1} style={{ marginTop: 6}}>
						<form action={this.getConfig().host + '/Home/Excel'} method='POST'>
							{exportData.map((excelFormField, index) => {
								return (<input key={index} type='hidden' name={excelFormField.name} value={excelFormField.value} />);
							})}
							<OverlayTrigger trigger="hover" overlay={<Popover><Popover.Header as="h3">Export to Excel</Popover.Header></Popover>}>
							  <input type='image' src={this.getConfig().host + '/Content/Icons/Excel.png'} style={{ paddingLeft: '20px' }} alt="Export to Excel" />
							</OverlayTrigger>
						</form>
					  </Col>
					  <Col xs={1} style={{ marginTop: 6}}>
						<form action={this.getConfig().host + '/Home/Pdf'} method='POST'>
							{exportData.map((pdfFormField, index) => {
								return (<input key={index} type='hidden' name={pdfFormField.name} value={pdfFormField.value} />);
							})}
							<OverlayTrigger trigger="hover" overlay={<Popover><Popover.Header as="h3">Export to PDF</Popover.Header></Popover>}>
							  <input type='image' src={this.getConfig().host + '/Content/Icons/Pdf.png'} style={{ paddingLeft: '20px' }} alt="Export to PDF" />
							</OverlayTrigger>
						</form>
					  </Col>
					  <Col xs={7}>
						<Button id="update" variant="warning" type="button" className="float-end" onClick={(event) => this.onSubmitSearch(event)}>Search</Button>
					  </Col>
					</Form.Group>
				  </Container>
				</Col>
			  </Row>
			  <Row>
				<Col>
				  <QueryTable renderKey={this.state.renderKey} parent={this} name='HeLAD_Products' table={this.state.productList}
				    onResult={(data) => this.onSearchResult(data)} offsetHeight='315px' />
				</Col>
			  </Row>
			</Container>
		</>);		
	}
}

const productSearch = [
	{ Header: 'Name', accessor: 'PRODUCT_NAME', row: 0, col: 0 },
	{ Header: 'Description', accessor: 'PRICE_DESC', row: 0, col: 1 }
];

const productList = {
	query: { entity: 'LIQUID_AIR.DEWAR_PRODUCTS_VW', search: null },
	pageSize: 20,
	columns: [
		{ Header: props => <PlusSquare style={{ cursor: 'pointer' }} onClick={() => props.parent.addProduct()} />, accessor: 'id', 
			Cell: props => <PencilSquare style={{ cursor: 'pointer' }} onClick={() => props.parent.editProduct(props.row.values.PRODUCT_ID)} />, width: 25 },
		{ Header: '', accessor: 'PRODUCT_ID', show: false },
		{ Header: 'Product', accessor: 'PRODUCT_NAME', width: 150,
			Cell: props => <HashLink onClick={() => props.parent.viewProduct(props.row.values.PRODUCT_ID)}>{props.value}</HashLink> },
		{ Header: 'State', accessor: 'PRODUCT_STATE', width: 60 },
		{ Header: 'Unit', accessor: 'UNIT_NAME', width: 70 },
		{ Header: 'Price', accessor: 'UNIT_PRICE', width: 60 },
		{ Header: 'Description', accessor: 'PRICE_DESC', width: 200 },
		{ Header: 'Ratio %', accessor: 'RATIO_AMOUNT', width: 70 },
		{ Header: 'Convers. %', accessor: 'CONVERSION_RATIO', width: 90 },
		{ Header: 'Desc.', accessor: 'RATIO_DESC', width: 200 },
		{ Header: 'Valid From', accessor: 'START_VALID_DATE_DISPLAY', width: 90 },
		{ Header: 'Valid To', accessor: 'END_VALID_DATE_DISPLAY', width: 90 }
	]
};

const exportColumns = [
	{ Header: 'Picked', accessor: 'REQUESTED_DELIVERY_DATE_DISPLAY', width: 16 },
	{ Header: 'Requested', accessor: 'DATE_REQUESTED_DISPLAY', width: 18 },
	{ Header: 'Size', accessor: 'CONT_TYPE', width: 18 },
	{ Header: 'Filled', accessor: 'FILLED', width: 14 },
	{ Header: 'Speedtype', accessor: 'COST_CENTER', width: 25 },
	{ Header: 'PI', accessor: 'PI_NAME', width: 40 },
	{ Header: 'Department', accessor: 'DEPARTMENT', width: 50 },
	{ Header: 'Canceled', accessor: 'CANCEL_FLAG_DISPLAY', width: 15 },
	{ Header: 'Req. ID', accessor: 'REQUEST_ID', width: 14 },
	{ Header: 'Date Billed', accessor: 'DATE_BILLED_DISPLAY', width: 18 }
];

export default withRouter(Products);
